// Import dependencies
import Vue from 'vue'
import VueI18n from 'vue-i18n'

// Import languages
import en from './en'
import es from './es'
import fr from './fr'
import pt from './pt'

// Global config
Vue.use(VueI18n)

// Export
export default new VueI18n({
	locale: 'pt',
	messages: {
        en,
        es,
        fr,
        pt
	}
})
